import styled from "@emotion/styled";
import { colors } from "src/theme";

export const InputStyle = styled.input((props: { 
  hasError: boolean, 
  colors?: { 
    background?: string, 
    text?: string,
    disabledBackground?: string,
    disabledText?: string
  },
  disabled?: boolean,
  value?: any
}) => {
  return {
    boxSizing: 'border-box' as const,
    outline: 'none',
    display: 'block',
    width: '100%',
    //height: '44px',
    padding: '10px 16px',
    fontSize: '18px',
    fontWeight: 400,
    fontStyle: 'normal',
    fontFamily: "Red Hat Text, sans-serif",
    lineHeight: '24px',
    color: colors.text3,
    // backgroundColor: props.disabled ? customColors.disabledBackground : customColors.background,
    backgroundColor: 'transparent',
    borderRadius: '8px',
    border: `1px solid ${props.hasError ? colors.error1 : colors.border5}`,
    transition: 'border-color .15s ease-in-out, box-shadow .15s ease-in-out',

    '&[disabled]': {
      border: `1px solid ${colors.border5}`,
      color: colors.text4,
      pointerEvents: 'none' as const,
    },

    '&::-moz-placeholder': {
      color: colors.text4,
      opacity: 1,
    },

    '&:-ms-input-placeholder': {
      color: colors.text4,
    },

    '&::-webkit-input-placeholder': {
      color: colors.text4,
    },

    '&:focus::-moz-placeholder': {
      color: 'transparent',
      opacity: 1,
    },

    '&:focus:-ms-input-placeholder': {
      color: 'transparent',
    },

    '&:focus::-webkit-input-placeholder': {
      color: 'transparent',
    },

    '&:focus': {
      borderColor: colors.border4,
    },

    '&[type=number]::-webkit-inner-spin-button, &[type=number]::-webkit-outer-spin-button': {
      WebkitAppearance: 'none' as const,
      MozAppearance: 'none' as const,
      appearance: 'none' as const,
    },
  }
});